import { AlertTriangle } from "lucide-react";

interface ErrorCardProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export const ErrorCard = ({
  title = "Something went wrong",
  message,
  onRetry,
}: ErrorCardProps) => (
  <div className="bg-destructive/5 border border-destructive/20 rounded-card p-5 flex items-start gap-3">
    <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
    <div className="flex-1">
      <p className="text-sm font-semibold text-destructive">{title}</p>
      <p className="text-sm text-destructive/80 mt-1">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 text-xs font-semibold text-destructive underline underline-offset-2"
        >
          Retry
        </button>
      )}
    </div>
  </div>
);

export default ErrorCard;
